import { Add as AddIcon, GetApp as GetAppIcon } from "@mui/icons-material";
import { Box, Button, Container, Fab, Tooltip, Typography } from "@mui/material";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

import { MeteoTable } from "src/components/MeteoTable";
import { PageHeader } from "src/components/page/PageHeader";
import { useTemplates, usePermissions } from "src/hooks";
import { isDisabled } from "src/utils/permission.utils";
import { useMeteos } from "src/hooks/custom-meteo";
import { IsEnabled } from "src/components/permissions";

interface Props {}

export function MeteoPage(props: Props) {
  const { t } = useTranslation();
  const { data: permissions } = usePermissions();
  const { data: templates } = useTemplates();
  const { data: meteos } = useMeteos();

  return render();

  function render() {
    if (!meteos || !permissions || !templates) return null;

    return (
      <StyledContainer maxWidth="lg">
        <PageHeader>
          <Typography variant="h3" noWrap className="page-title">
            {t("title.meteoManagement")}
          </Typography>
          <Box display="flex" flexGrow={1} />

          <Button
            className="button"
            component="a"
            startIcon={<GetAppIcon />}
            href={templates.meteoTemplateUrl}
            download
            disabled={isDisabled(permissions.background.downloadTemplate)}
          >
            {t("label.templateFile")}
          </Button>

          <IsEnabled permission={permissions.customMeteo.create}>
            <Tooltip title={t<string>("tooltip.newMeteo")} placement="left">
              <Fab className="button fab" color="primary" aria-label="add">
                <AddIcon />
              </Fab>
            </Tooltip>
          </IsEnabled>
        </PageHeader>

        <MeteoTable className="meteo-table" data={meteos} />
      </StyledContainer>
    );
  }
}

const StyledContainer = styled(Container)`
  padding: ${({ theme }) => theme.spacing(3)};
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;

  .page-title {
    margin-bottom: ${({ theme }) => theme.spacing(3)};
  }
  .button {
    & + .button {
      margin-left: ${({ theme }) => theme.spacing(1)};
    }
  }

  .page-title {
    margin-bottom: ${({ theme }) => theme.spacing(3)};
  }

  .meteo-table {
    height: 0;
    flex: 1 1 100px;
  }

  .button {
    & + .button {
      margin-left: ${({ theme }) => theme.spacing(1)};
    }
  }
`;
